










import { Component, Vue } from "vue-property-decorator";
import HomeHeader from "@/components/home/HomeHeader.vue";
import HomeInformation from "@/components/home/HomeInformation.vue";
@Component({
    components: { HomeInformation, HomeHeader }
})
export default class Home extends Vue {}
